export default {
    path : "land-carrier-focus",
    name : "land-carrier-focus",
    meta : {
        title : "关注载体"
    },
    component: () => import('@/pages/land/focusCarrier/Index'),
    redirect: {
        name : "land-carrier-focus-whole"
    },
    children: [
        {
            path: 'all',
            name: 'land-carrier-focus-whole',
            meta: {
                title: '土地载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'recent',
            name: 'land-carrier-focus-recent',
            meta: {
                title: '土地载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'atme',
            name: 'land-carrier-focus-atme',
            meta: {
                title: '土地载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'meat',
            name: 'land-carrier-focus-meat',
            meta: {
                title: '土地载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'reply',
            name: 'land-carrier-focus-reply',
            meta: {
                title: '土地载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'search',
            name: 'land-carrier-focus-search',
            meta: {
                title: '土地载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'update',
            name: 'land-carrier-focus-update',
            meta: {
                title: '土地载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/land/focuscarrier/index.js